import store from './store'
import Firebase from 'firebase'

import config from './firebase'

export default {
  install: (Vue, options) => {
    const firebase = Firebase.initializeApp(config)
    const auth = firebase.auth()
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return await auth.signInWithEmailAndPassword(username, pass)
      },
      logout: async () => {
        await auth.signOut()
      },
      register: async (username, pass, name) => {
        await auth.createUserWithEmailAndPassword(username, pass).then(user => {
          user.user.updateProfile({
            displayName: name
          })
        }).catch(err => {
          alert(err.message)
        })
        let user = firebase.auth().currentUser;
        user.displayName = name;
        return user

      },
      updateUser: async(user, username, pass, name) => {
        await user.updateEmail(username)
        if (pass) await user.updatePassword(pass)
        await user.updateProfile({
          displayName: name
        })
        store.commit('updateUser',{ user: auth.currentUser })
      }
    }
    auth.onAuthStateChanged(user => {
      store.commit('updateUser',{ user })
    })
  }
}